<template>
<div style=" overflow: auto;background-color: #F0F6FF;"  @scroll="handleScroll">
<header>
    <div class="header_div">
        <div class="header_div_img"><img src="../../assets/whatIsNewsimages/heard_img1.png"></div>
        <div class="search_no_result">
            <div class="search_no_result_div">
                <div class="search_no_result_div_img">
                    <img src="../../assets/whatIsNewsimages/error.png">
                </div>
                <div class="search_no_result_div_text">No results found in the search</div>
            </div>
        </div>
    </div>
</header>
<section>   
    <div class="section_div1">
        <div class="section_div1_div">
            <div class="section_div1_div_left">
                <div class="section_div1_div_left_left"><img src="../../assets/whatIsNewsimages/search_icon.png"></div>
                <div class="section_div1_div_left_right"><input @change=search() name="search"  class="section_div1_div_left_right_input" placeholder="Keyword search"/></div>
            </div>
            <div class="section_div1_div_right" ><img @click="search()" style="height: 10px;width: 30px;" src="../../assets/whatIsNewsimages/arrow.png"></div>
        </div>
    </div>
</section>
<section>
    <div class="section_div2">
        <div class="section_div2_div">What CSI provides:</div>
    </div>
</section>
<section>
    <div class="section_div3">
        <div class="section_div3_pagination">
            <div class="swiper-pagination1 ">
            </div>
        </div>
        <div class="swiper swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <div class="section_div3_swiper" name="all">
                        <ul>
                        </ul>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="section_div3_swiper">
                        <ul>
                            <li class="section_div3_swiper_li_margin" name="Search Companies">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li2_1.png"></div>
                                    <div class="section_div3_swiper_top_text">Conduct Global Company Searches</div>
                                    <div class="section_div3_swiper_top_text2">Identify and discover businesses anywhere in the world.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img" >
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li class="section_div3_swiper_li_margin" name="Search Companies">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li2_2.png"></div>
                                    <div class="section_div3_swiper_top_text">Verify Corporate Legitimacy</div>
                                    <div class="section_div3_swiper_top_text2">Confirm the legal registration and operational status of any entity.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li class="section_div3_swiper_li_margin" name="Search Companies">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li2_3.png"></div>
                                    <div class="section_div3_swiper_top_text">Uncover Ownership Structures</div>
                                    <div class="section_div3_swiper_top_text2">Gain clarity on corporate hierarchies and ultimate beneficial owners.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li name="Search Companies">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li2_4.png"></div>
                                    <div class="section_div3_swiper_top_text">Analyze Financial Performance</div>
                                    <div class="section_div3_swiper_top_text2">Access key financial data and performance metrics.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li class="section_div3_swiper_li_margin" name="Search Companies">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li2_5.png"></div>
                                    <div class="section_div3_swiper_top_text">Assess Local Creditworthiness</div>
                                    <div class="section_div3_swiper_top_text2">Review regional credit scores and risk evaluations.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li class="section_div3_swiper_li_margin" name="Search Companies">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li2_6.png"></div>
                                    <div class="section_div3_swiper_top_text">Access Import & Export Data</div>
                                    <div class="section_div3_swiper_top_text2">Track international shipping records and trade activities.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li class="section_div3_swiper_li_margin" name="Search Companies">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li2_7.png"></div>
                                    <div class="section_div3_swiper_top_text">Conduct Side-by-Side Analysis</div>
                                    <div class="section_div3_swiper_top_text2">Compare companies directly on key metrics.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li name="Search Companies">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li2_8.png"></div>
                                    <div class="section_div3_swiper_top_text">Data Export</div>
                                    <div class="section_div3_swiper_top_text2">Easily download and export your data for external analysis, reporting, or integration with other systems.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li class="section_div3_swiper_li_margin" name="Search Companies">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li2_9.png"></div>
                                    <div class="section_div3_swiper_top_text1">Report Data Errors & Update<br> Information</div>
                                    <div class="section_div3_swiper_top_text2">A streamlined system for users to flag inaccuracies and submit updates, ensuring continuous data integrity and freshness.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="section_div3_swiper">
                        <ul>
                            <li class="section_div3_swiper_li_margin" name="Search Leads">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li3_1.png"></div>
                                    <div class="section_div3_swiper_top_text">Identify Potential Customers</div>
                                    <div class="section_div3_swiper_top_text2">Discover and target your most promising sales prospects.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li class="section_div3_swiper_li_margin" name="Search Leads">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li3_2.png"></div>
                                    <div class="section_div3_swiper_top_text">Source Qualified Vendors</div>
                                    <div class="section_div3_swiper_top_text2">Find and vet reliable suppliers and partners.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li class="section_div3_swiper_li_margin" name="Search Leads">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li3_3.png"></div>
                                    <div class="section_div3_swiper_top_text">Acquire Market Intelligence</div>
                                    <div class="section_div3_swiper_top_text2">Gain actionable insights to inform your strategy.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li name="Search Leads">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li3_4.png"></div>
                                    <div class="section_div3_swiper_top_text">Access Key Decision-Maker Contacts</div>
                                    <div class="section_div3_swiper_top_text2">Get direct contact information for relevant personel.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                    
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="section_div3_swiper">
                        <ul>
                            <li class="section_div3_swiper_li_margin" name="Search Trade">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li4_1.png"></div>
                                    <div class="section_div3_swiper_top_text">Search Trade Data</div>
                                    <div class="section_div3_swiper_top_text2">Filter records by specific products, companies, or countries.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li class="section_div3_swiper_li_margin" name="Search Trade">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li4_2.png"></div>
                                    <div class="section_div3_swiper_top_text">Access Detailed Shipment Records</div>
                                    <div class="section_div3_swiper_top_text2">Review comprehensive import and export documentation.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li class="section_div3_swiper_li_margin" name="Search Trade">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li4_3.png"></div>
                                    <div class="section_div3_swiper_top_text">Analyze Market Trends</div>
                                    <div class="section_div3_swiper_top_text2">Study historical trade patterns and forecast market shifts.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li name="Search Trade">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li4_4.png"></div>
                                    <div class="section_div3_swiper_top_text">Visualize Supply Chain Networks</div>
                                    <div class="section_div3_swiper_top_text2">Map and understand end-to-end logistics and relationships.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li class="section_div3_swiper_li_margin" name="Search Trade">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li4_5.png"></div>
                                    <div class="section_div3_swiper_top_text">Leverage Trade Statistics</div>
                                    <div class="section_div3_swiper_top_text2">RUtilize official data for market research and strategy.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="section_div3_swiper">
                        <ul>
                            <li class="section_div3_swiper_li_margin" name="Search News">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li5_1.png"></div>
                                    <div class="section_div3_swiper_top_text">Search Company News</div>
                                    <div class="section_div3_swiper_top_text2">Monitoring any company developments</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="section_div3_swiper">
                        <ul>
                            <li class="section_div3_swiper_li_margin" name="Search Sanctions">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li6_1.png"></div>
                                    <div class="section_div3_swiper_top_text">Screen Against Global Sanction Lists</div>
                                    <div class="section_div3_swiper_top_text2">Search sanction records by company name or products</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                             <li class="section_div3_swiper_li_margin" name="Search Sanctions">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li6_2.png"></div>
                                    <div class="section_div3_swiper_top_text">Access Sanction Data Statistics</div>
                                    <div class="section_div3_swiper_top_text2"></div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="section_div3_swiper">
                        <ul>
                            <li class="section_div3_swiper_li_margin" name="Search UBO">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li7_1.png"></div>
                                    <div class="section_div3_swiper_top_text1">Analyze the Corporate Shareholding Structure</div>
                                    <div class="section_div3_swiper_top_text2">Eeview the company's ownership framework and equity distribution.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                             <li class="section_div3_swiper_li_margin" name="Search UBO">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li7_2.png"></div>
                                    <div class="section_div3_swiper_top_text1">Unpack Complex Ownership Hierarchies</div>
                                    <div class="section_div3_swiper_top_text2">Examin and penetrate multi-layered corporate entities to trace ownership pathways.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                             <li class="section_div3_swiper_li_margin" name="Search UBO">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li7_3.png"></div>
                                    <div class="section_div3_swiper_top_text1">Identify the Ultimate Beneficial Owner (UBO)</div>
                                    <div class="section_div3_swiper_top_text2">Determin the individual(s) who ultimately own or control the company.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="section_div3_swiper">
                        <ul>
                            <li class="section_div3_swiper_li_margin" name="Risk Scan">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li8_1.png"></div>
                                    <div class="section_div3_swiper_top_text">Centralized Portfolio Management</div>
                                    <div class="section_div3_swiper_top_text2">Manage your entire client and vendor data portfolio from a single, unified platform.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li class="section_div3_swiper_li_margin" name="Risk Scan">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li8_2.png"></div>
                                    <div class="section_div3_swiper_top_text">Automated Data Cleansing</div>
                                    <div class="section_div3_swiper_top_text2">Ensure data integrity with one-click processing to standardize and validate all portfolio information.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li class="section_div3_swiper_li_margin" name="Risk Scan">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li8_3.png"></div>
                                    <div class="section_div3_swiper_top_text">Comprehensive Risk Factor Analysis</div>
                                    <div class="section_div3_swiper_top_text2">Investigate and evaluate all relevant data points to conduct a thorough risk assessment.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li name="Risk Scan">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li8_4.png"></div>
                                    <div class="section_div3_swiper_top_text">Dynamic Risk Visualization</div>
                                    <div class="section_div3_swiper_top_text2">Gain immediate insights through intuitive dashboards that map risk exposure by key factors.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li class="section_div3_swiper_li_margin" name="Risk Scan">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li8_5.png"></div>
                                    <div class="section_div3_swiper_top_text1">Integrated Market & Industry Intelligence</div>
                                    <div class="section_div3_swiper_top_text2">Access market data and critical industry benchmarks to inform strategic decisions.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="section_div3_swiper">
                        <ul>
                            <li class="section_div3_swiper_li_margin" name="Order Reports">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li9_1.png"></div>
                                    <div class="section_div3_swiper_top_text">Instant Online Report Download</div>
                                    <div class="section_div3_swiper_top_text2">Access and download standard credit reports immediately upon request.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li class="section_div3_swiper_li_margin" name="Order Reports">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li9_2.png"></div>
                                    <div class="section_div3_swiper_top_text1">Order Fresh, Investigated Credit<br> Reports</div>
                                    <div class="section_div3_swiper_top_text2">Commission newly conducted, in-depth credit analyses for the most current and comprehensive view.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li class="section_div3_swiper_li_margin" name="Order Reports">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li9_3.png"></div>
                                    <div class="section_div3_swiper_top_text">Continuous Monitoring Services</div>
                                    <div class="section_div3_swiper_top_text2">Receive proactive alerts and updates through ongoing monitoring of your subjects of interest.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="section_div3_swiper">
                        <ul>
                            <li class="section_div3_swiper_li_margin" name="Verificaiton">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li10_1.png"></div>
                                    <div class="section_div3_swiper_top_text">Business Process Verification</div>
                                    <div class="section_div3_swiper_top_text2">An in-depth audit of internal workflows, policies, and operational procedures to ensure compliance and efficiency.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li class="section_div3_swiper_li_margin" name="Verificaiton">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li10_2.png"></div>
                                    <div class="section_div3_swiper_top_text">On-Site Field Verification</div>
                                    <div class="section_div3_swiper_top_text2">Physical inspection and validation of business operations, assets, and information at their source or location.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="section_div3_swiper">
                        <ul>
                            <li class="section_div3_swiper_li_margin" name="Search Countries">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li11_1.png"></div>
                                    <div class="section_div3_swiper_top_text1">One-Stop Access to Macroeconomic Data</div>
                                    <div class="section_div3_swiper_top_text2">A centralized platform for comprehensive, country-level economic indicators and market intelligence.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>                           
                        </ul>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="section_div3_swiper">
                        <ul>
                            <li class="section_div3_swiper_li_margin" name="Data Services">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/bg.jpg" style="border-radius: 20px;"></div>
                                    <div class="section_div3_swiper_top_text">Data Cleansing & Enrichment</div>
                                    <div class="section_div3_swiper_top_text2">Ensure data accuracy and enhance value through automated validation, correction, and enrichment processes.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li class="section_div3_swiper_li_margin" name="Data Services">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/bg.jpg" style="border-radius: 20px;"></div>
                                    <div class="section_div3_swiper_top_text">API Integration Service</div>
                                    <div class="section_div3_swiper_top_text2">Connect and operationalize our dataset and insights directly into your existing workflows and applications.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li class="section_div3_swiper_li_margin" name="Data Services">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/bg.jpg" style="border-radius: 20px;"></div>
                                    <div class="section_div3_swiper_top_text">Enterprise-Grade Bulk Data</div>
                                    <div class="section_div3_swiper_top_text2">Power your advanced analytics and AI initiatives with robust, scalable bulk data solutions.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="section_div3_swiper">
                        <ul>
                            <li class="section_div3_swiper_li_margin" name="Zaba AI Chatbot">
                                <div class="section_div3_swiper_top">
                                    <div class="section_div3_swiper_top_div"><img src="../../assets/whatIsNewsimages/li13_1.png"></div>
                                    <div class="section_div3_swiper_top_text1">Instant Intelligence Through Natural Language</div>
                                    <div class="section_div3_swiper_top_text2">Ask business questions in plain language and receive immediate, data-driven answers and insights from CSI's private data pool.</div>
                                    <div class="section_div3_swiper_bottom" onclick="showDialog(this);">
                                        <div class="section_div3_swiper_bottom_div_img">
                                                <img src="../../assets/whatIsNewsimages/add.png">
                                        </div>
                                    </div>
                                </div>
                            </li>                           
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="section_div3_swiper_more swiper_more_active" style="cursor: pointer;" @click="showAllHtml();">Show All</div>
    </div>
</section>
<footer>
    <div class="footer_div">
        <div class="footer_div_top">
            <div class="footer_div_top_div"><img src="../../assets/whatIsNewsimages/csi_icon.png"></div>
        </div>
        <div class="footer_div_bottom">
            <div class="footer_div_bottom_left">Our data and coverage is your worldwide resource for Business Intelligence and Business Analytics!</div>
            <div class="footer_div_bottom_right">Copyright 2024 Company Search, Inc. All Rights Reserved.</div>
        </div>
    </div>
</footer>
<div class="section_bg_div"></div>
<dialog id="myDialog">
    <div class="dialog_div">
        <div class="dialog_div_body_left">
            <img src="../../assets/whatIsNewsimages/li2_1.png">
        </div>
        <div class="dialog_div_body_right">
            <div class="dialog_div_body_right_top">
                <div class="dialog_div_body_right_top_tab">Search Companies</div>
            </div>
            <div class="dialog_div_body_right_middle">Conduct Global Company Searches</div>
            <div class="dialog_div_body_right_tottom">
                Identify and discover businesses anywhere in the world. Confirm the legal
                registration and operational status of any entity.
                Identify and discover businesses anywhere in the world. 
                Identify and discover businesses anywhere in the world.
                Confirm the legal registration and operational status of any entity.
            </div>
        </div>
        <div class="dialog_div_close_div" onclick="document.getElementById('myDialog').close();">
            <img src="../../assets/whatIsNewsimages/close.png">
        </div>
    </div>
</dialog>
</div>
</template>

<script>
import Swiper, { Pagination } from 'swiper';
Swiper.use([Pagination]);

export default {

  components: {
  },
  data() {
    return {
        index:1,
        showAll:true,
      swiper:null,
        activeHtml:'',
        list:['All','Search Companies','Search Leads','Search Trade','Search News'
    ,'Search Sanctions','Search UBO','Risk Scan','Order  Reports','Verificaiton'
    ,'Search Countries','Data Services','Zaba AI Chatbot'],

    
    }
  },
  methods: { 
       getLsit(){
        let that =this
      document.addEventListener('DOMContentLoaded', function() {   
        document.getElementsByClassName('search_no_result')[0].style.display = 'none';   
    
        document.addEventListener('keydown', function (event) {
            if (event.keyCode === 13) { 
                that.search();
            }
        });

        // window.addEventListener('scroll', function () {
        //     console.log(`111`, 111);
        //    
        // });
    });

    },

    updatePagination(i) {
        let that=this
        const fitImg = require('@/assets/whatIsNewsimages/fit.png'); 
        const bullets = document.querySelectorAll('.swiper-pagination1 .swiper-pagination-bullet');
   bullets.forEach((bullet, index) => {
  if (index === i) {
    // 完全用模板字符串，不要混用 + 和多余的引号
    bullet.innerHTML = `<div class="section_div3_pagination_img">
                          <img src="${fitImg}" alt="fit" />
                        </div>${that.list[index]}`;
  } else {
    bullet.textContent = that.list[index]; // textContent 更安全（自动转义）
  }
});
    },
    search(){
        document.getElementsByClassName('search_no_result')[0].style.display = 'none';
        let input=document.getElementsByName('search')[0].value;
       
        
        if(input==undefined || input==''){
            if(this.swiper.activeIndex==0){
                const all = document.querySelectorAll("[name='all'] ul");
                all[0].innerHTML = '';
                this.index = 1;
                this.showAll = true;
              this.removeActive();
              
                  this.showAllHtml();
            }
            else{
                document.querySelectorAll('.swiper-slide-active ul')[0].innerHTML= this.activeHtml;
            }
        }
                if(input!=undefined && input!=''){
            //
            const all = document.querySelectorAll(".swiper-slide-active ul");
            var liHtml = '';

            var i = 0;

            if(this.swiper.activeIndex==0){
                let lis = document.querySelectorAll('.section_div3_swiper li');
                var len= document.querySelectorAll('.swiper-slide-active li').length;
                lis = Array.from(lis).slice(len, lis.length);
                lis.forEach((text, index)=>{
                     if (text.children[0].children[1].textContent.toLowerCase().indexOf(input.toLowerCase()) !== -1) {
                        i++;
                        var name = text.getAttribute("name");
                        if (i % 4 == 0) {
                            liHtml += "<li name='" + name + "'>";
                        }
                        else {
                            liHtml += '<li class="section_div3_swiper_li_margin" name="' + name + '">';
                        }
                        liHtml += text.innerHTML;
                        liHtml += "</li>";
                    }
                });
            }
            else{
                const texts = document.querySelectorAll('.swiper-slide-active .section_div3_swiper_top_text');
                const texts1 = document.querySelectorAll('.swiper-slide-active .section_div3_swiper_top_text1');


                texts.forEach((text, index) => {
                    if (text.textContent.toLowerCase().indexOf(input.toLowerCase()) !== -1) {
                        i++;
                        var name = text.parentNode.parentNode.getAttribute("name");
                        if (i % 4 == 0) {
                            liHtml += "<li name='" + name + "'>";
                        }
                        else {
                            liHtml += '<li class="section_div3_swiper_li_margin" name="' + name + '">';
                        }
                        liHtml += text.parentNode.parentNode.innerHTML;
                        liHtml += "</li>";
                    }

                });

                texts1.forEach((text, index) => {
                    if (text.textContent.toLowerCase().indexOf(input.toLowerCase()) !== -1) {
                        i++;
                        var name = text.parentNode.parentNode.getAttribute("name");
                        if (i % 4 == 0) {
                            liHtml += "<li name='" + name + "'>";
                        }
                        else {
                            liHtml += '<li class="section_div3_swiper_li_margin" name="' + name + '">';
                        }
                        liHtml += text.parentNode.parentNode.innerHTML;
                        liHtml += "</li>";
                    }
                });
            }

            if(liHtml!=''){
                all[0].innerHTML = '';
                all[0].innerHTML += liHtml;
            }
            else{
                document.getElementsByClassName('search_no_result')[0].style.display = 'block';
                setTimeout(function () {
                    document.getElementsByClassName('search_no_result')[0].style.display = 'none'; 
                }, 3000); 
            }
            
            this.showAll = false;
            this.removeActive();
            
        };
   
   
   
    },
    showAllHtml(){
        let that=this
        
        if(document.getElementsByClassName('section_div3_swiper_more')[0].textContent!='Show All')

            return;
            console.log(`111`, 111);
        let lis = document.querySelectorAll('.section_div3_swiper li');
        lis = Array.from(lis).slice(16 * (that.index - 1),lis.length);
        const all =document.querySelectorAll("[name='all'] ul");

        if(16 * (that.index - 1) >=lis.length)
            return;

        let liHtml='';
        const min = 16 * (that.index-1) + 1;
        const max = 16 * that.index >=lis.length ? lis.length + 1 : 16 * that.index + 1;
          for(var i = min;i < max ;i++){
            var name= lis[i - 1].getAttribute("name");
            if(i % 4 == 0){
                liHtml+="<li name='"+name+"'>";
            }
            else{
                liHtml+='<li class="section_div3_swiper_li_margin" name="'+name+'">';
            }
            liHtml+=lis[i-1].innerHTML;
            liHtml+="</li>";
        }
        all[0].innerHTML += liHtml;
        that.index++;

          const allLength = document.querySelectorAll("[name='all'] li").length;
        if(allLength >=lis.length){
            this.showAll=false;
        }
    
        that.removeActive();
    },
removeActive(){
        if(this.showAll && this.swiper.activeIndex == 0){
            document.getElementsByClassName('section_div3_swiper_more')[0].classList.add("swiper_more_active");
            document.getElementsByClassName('section_div3_swiper_more')[0].innerHTML='Show All';
        }
        else{
            document.getElementsByClassName('section_div3_swiper_more')[0].classList.remove("swiper_more_active");
            document.getElementsByClassName('section_div3_swiper_more')[0].innerHTML='No More';
        }
    },
     showDialog(e){
        console.log(`e`, e);
        var img1 = e.parentNode.parentNode.children[0].children[0].innerHTML;
        var txt1= e.parentNode.parentNode.children[0].children[1].innerHTML;
        var txt2= e.parentNode.parentNode.children[0].children[2].innerHTML;
        var name= e.parentNode.parentNode.getAttribute("name")

        document.querySelector('#myDialog .dialog_div_body_left').innerHTML= img1;
        document.querySelector('#myDialog .dialog_div_body_right_middle').innerHTML = txt1.replace(/<br\s*\/?>/gi, '');;
        document.querySelector('#myDialog .dialog_div_body_right_tottom').innerHTML = txt2;
        document.querySelector('#myDialog .dialog_div_body_right_top_tab').innerHTML = name;
        document.getElementById('myDialog').showModal();
    },
    handleScroll(){
    var element = document.querySelector('.section_div3_pagination');
            var rect = element.getBoundingClientRect();
            var bg = document.querySelector('.section_bg_div'); 
            if (rect.top == 0) {
                bg.style.display='block';
            } else {
                bg.style.display = 'none';
            }
    }
 
  },
    created() {
    window.addEventListener('scroll', this.handleScroll);

  },
//     beforeUnmount() {
//     // 移除页面滚动事件的监听
//     window.removeEventListener('scroll', this.handleScroll);
//   },
  mounted() {
   
 
    let that =this
    // 在组件顶部或 methods 外先解析一次
const fitImg = require('@/assets/whatIsNewsimages/fit.png'); 

  this.swiper = new Swiper(".swiper", {
    
        initialSlide:0,
        autoHeight: true,
        pagination: {
        el: ".swiper-pagination1",
        clickable: true,
     renderBullet: function(index, className) {
  var text = that.list && that.list[index] ? that.list[index] : '';
  if (index === 0) {
    return '<div class="' + className + ' swiper-pagination-bullet_first">' +
             '<div class="section_div3_pagination_img">' +
               '<img src="' + fitImg + '" alt="fit" />' +
             '</div>' +
             '<div class="section_div3_pagination_text">' + text + '</div>' +
           '</div>';
  } else {
    return '<div class="' + className + '">' + text + '</div>';
  }
}
        },
        observer: true,
        observeParents: true,
         allowTouchMove: false
    });

    that.swiper.on('slideChange', function (e) {
        if(that.swiper.activeIndex==0){
            window.location.reload();
        }
        
        document.getElementsByClassName('search_no_result')[0].style.display = 'none';
        document.getElementsByName('search')[0].value='';
        that.showAll = true;
    that.removeActive();
       that.updatePagination(e.activeIndex)
    });
    that.swiper.on('slideChangeTransitionEnd', function (e) {
        that.activeHtml = document.querySelectorAll('.swiper-slide-active .section_div3_swiper ul')[0].innerHTML;
    });
       that.getLsit()
        that.showAllHtml();
        window.showDialog = this.showDialog.bind(this)

  },
   beforeDestroy() {
    // 移除监听器，防止内存泄漏或重复绑定
    document.removeEventListener('keydown', this._enterHandler);
    window.removeEventListener('scroll', this._scrollHandler);
  },

};

</script>

<style scoped>

    .img {
	max-width: 100%;
	height: auto;
}
a img { 
	border: 0; 
}

li,ol{
	list-style: none;
}

/deep/ header{
	width: 100%;
	height: auto;
	padding-left: 1%;
	padding-right: 1%;
}

/deep/ section{
	width: 100%;
	height: auto;
}

/deep/ footer{
	width: 100%;
	height: auto;
}

/deep/ .header_div{
position: relative;
	width: 100%;
	height: auto;
	margin-bottom: 30px;
    padding-top: 10px;}
/deep/ .search_no_result{
	display: none;
	position: absolute;
	width: 100%;
	top: 20px;
	height: auto;
	
}
/deep/ .search_no_result_div{
	width: 600px;
	height: 80px;
	margin: 0 auto;
	background-color: #FFECEC;
	border: 1px solid #F56B6B;
	border-radius: 20px;
}
/deep/ .search_no_result_div_img{
	float: left;
	width: 20px;
	height: 20px;
	padding-top: 30px;
	padding-bottom: 30px;
	padding-left: 145px;
	margin-right: 10px;
}
/deep/ .search_no_result_div_text{
	float: left;
	width: auto;
	height: 30px;
	padding-top: 25px;
	padding-right: 25px;
	line-height: 30px;
	font-family: "Arial" !important;
	font-size: 20px;
	color: #F56B6B;
}

/deep/ .header_div_img{
position: relative;
    width: 100%;
    height: auto;
    margin: 0 auto;
}

/deep/ .section_div1{
	width: 100%;
	height: auto;
} 
/deep/ .section_div1_div{
      width: 490px;
    height: 50px;
	margin: 0 auto;
	margin-bottom: 10px;
    justify-content: center;
    display: flex;
    align-items: center;
	padding: 5px;
	border-radius: 30px;
	background-color: #ffffff;
}

/deep/ .section_div1_div_left{
	float: left;
	width: 410px;
	height: 50px;
	padding-left: 30px;
}

/deep/ .section_div1_div_left_left{
	float: left;
	width: 20px;
	height: 20px;
	margin-right: 10px;
	padding-top: 15px;
	padding-bottom: 15px;
}

/deep/ .section_div1_div_left_right{
	position: relative;
	float: left;
	width: 350px;
	height: 30px;
	padding-top: 10px;
	padding-bottom: 10px;
}

 /deep/ .section_div1_div_left_right_input{
	position: absolute;
	top: 11px;
	left: 0;
	width: 100%;
	height: 30px;
	line-height: 30px;
	font-family: "Arial" !important;
	font-size: 16px;
	color: #1A2332;
	border: 0;
	background-color: transparent;
	z-index: 99;
}

/deep/ .section_div1_div_right{
	float: left;
	width: 46px;
	height: 46px;
	padding-left: 15px;
	padding-right: 15px;
	padding-top: 19px;
	padding-bottom: 19px;
	border-radius: 50%;
	background-color: #1290C9;
	z-index: 99;
}

 /deep/ .section_div1_div_right img{
	display: block;
}

/deep/ .section_div2{
	width: 1760px;
	height: 20px;
	margin: 0 auto;
	/* margin-bottom: 20px; */
}

/deep/ .section_div2_div{
	width: 1760px;
	height: 20px;
	line-height: 20px;
	padding-top: 0px;
	padding-left: 0px;
  font-family: "Arial bold";

	font-size: 16px;
	color: #1A2332;
}

/deep/ .section_div3{
	width: 1760px;
	height: auto;
	margin: 0 auto;
	margin-bottom: 60px;
    
}

/* swiper */
/deep/ .swiper-pagination-bullets, /deep/ .swiper-pagination-bullet,
/deep/ .swiper-pagination-horizontal ,/deep/ .swiper-pagination-bullets,/deep/ .swiper-pagination-bullet{margin:0 0 0 var(--swiper-pagination-bullet-horizontal-gap,5px)!important}
/deep/ .swiper-pagination-bullet-active{background: #1290C9!important;color: #FFFFFF!important;border: 1px solid #1290C9 !important;}
/deep/ .swiper-pagination-bullet-active,/deep/ .section_div3_pagination_text{color: #FFFFFF!important;}
/deep/ .swiper {
	width: 100%;
	height: auto!important;
	/* margin-bottom: 10px; */
	padding-top: 30px !important;
	/* padding-bottom: 30px !important; */
}
/deep/ .swiper-slide {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 300px;
}

/deep/ .section_div3_active{
	color: #FFFFFF!important;
}

 /deep/ .section_div3_pagination{
	position: sticky;
	top: 0;
	width: 100%;
	height: auto;
	padding-top: 20px;
	padding-bottom: 20px;
	z-index: 9999;
}

/deep/ .swiper-pagination-bullet{
	width: auto;
	height: 38px;
	line-height: 38px;
	padding-left: 10px;
	padding-right: 10px;
	border: 1px solid #8497AB;
	border-radius: 20px;
	text-align: center;
font-family: "Arial" !important;
	font-size: 16px;
	color: #1A2332;
    background-color: transparent;
    opacity: 1;
}
/deep/ .swiper-pagination-bullet_first{
	width: 60px;
}

 /deep/ .section_div3_pagination_img{
	float: left;
	width: 14px;
	height: 10px;
	padding-top: 15px;
	padding-bottom: 4px;
	margin-right: 5px;


}

/deep/ .section_div3_pagination_img img{
	display: block;
}

/deep/ .section_div3_pagination_text{
font-family: "Arial" !important;
	font-size: 16px;
	text-align: center;
	color: #1A2332;
}

/deep/ .section_div3_swiper{
	width: 1760px;
	height: auto;
	margin: 0 auto;
}

/deep/ .section_div3_swiper_more{
	width: 100%;
	height: 20px;
	line-height: 20px;
font-family: "Arial" !important;
	font-size: 20px;
	color: #8497AB;
	text-align: center;
}

/deep/ .swiper_more_active{
	color: #1290C9!important;
}

 /deep/ .li_active{
	display: none;
}

 /deep/ .section_div3_swiper_li_margin{
	margin-right: 32px;
}

 /deep/ .section_div3_swiper li{
	position: relative;
	float: left;
	width: 414px;
	height: 490px;
	margin-bottom: 40px;
	border-radius: 26px;
	background-color: #ffffff;
	/* box-shadow: 0 3px 20px 0 rgba(11,65,92,0.1); */
	z-index: 99;
	border: 1px solid #eeeeee;
}

/deep/ .section_div3_swiper_top{
		width: 396px;
	height: auto;
	padding-left: 20px;
	padding-top: 20px;
}

/deep/ .section_div3_swiper_top_div{
	width: 376px;
	height: 240px;
	margin-bottom: 15px;
	background: #ededed;
	border-radius: 20px;
}

/deep/ .section_div3_swiper_top_text1{
	width: auto;
	height: 50px;
	line-height: 25px;
  font-family: "Arial bold";
  	font-size: 20px;
	color: #1A2332;
	margin-bottom: 10px;
}

/deep/ .section_div3_swiper_top_text {
	width: 386px;
	height: 40px;
	line-height: 40px;
	
      font-family: "Arial bold";
	font-size: 20px;
	color: #1A2332;
	margin-bottom: 10px;
}

/deep/ .section_div3_swiper_top_text2{
	width: 376px;
	height: 70px;
	line-height: 28px;
font-family: "Arial" !important;
	font-size: 18px;
	color: #8497AB;
}

 /deep/ .section_div3_swiper_bottom{
	position: absolute;
	bottom: 30px;
	right: 30px;
	width: 46px;
	height: 46px;
	padding: 13px;
	border-radius: 30px;
	background-color: #1290C9;
}

/deep/ .section_div3_swiper_bottom_div_img{
	width: 20px;
	height: 20px;
}

/deep/ .section_div3_swiper_bottom_div_img img{
	display: block;
}

/deep/ .section_bg_div{
	position: fixed;
	top:0;
	left: 0;
	width: 100%;
	height: 80px;
    background: #F0F6FF ;
	box-shadow: 0px 10px 20px 0px rgba(38, 57, 67, 0.2);
	display: none;
	z-index: 9;
}


/deep/ .footer_div{
	width: 1760px;
	height: auto;
	margin: 0 auto;
}

/deep/ .footer_div_top{
	float: left;
	width: 100%;
	padding-bottom: 12px;
	border-bottom:1px solid #B7C5D5;
}

/deep/ .footer_div_top_div{
	float: left;
	width: 70px;
	height: 22px;
}

/deep/ .footer_div_bottom{
	float: left;
	width: 100%;
	padding-top: 15px;
	padding-bottom: 15px;
}

/deep/ .footer_div_bottom_left{
	float: left;
	width: 50%;
	height: 20px;
	line-height: 20px;
	 font-family: "Arial" !important;
	font-size: 14px;
	color: #1A2332;
}

/deep/.footer_div_bottom_right{
	float: left;
	width: 50%;
	height: 20px;
	line-height: 20px;
font-family: "Arial" !important;
	font-size: 14px;
	color: #1A2332;
	text-align: right;
}

/deep/ dialog {
	position: fixed;
	top: 50%;
	left: 50%;
	width: 1140px;
	border: none;
	border-radius: 40px;
	background-color: white;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
	transform: translate(-50%, -50%);
	z-index: 9999;
}

/deep/ dialog::backdrop {
	background-color: rgba(0, 0, 0, 0.5);
}

/deep/.dialog_div{
	position: relative;
	width: 1080px;
	height: 380px;
	margin: 0 auto;
	padding: 30px;
    display: flex;
        border: none;
}

/deep/ .dialog_div_close_div {
	position: absolute;
	width: 26px;
	height: 26px;
	top: 30px;
	right: 30px;
}

/deep/.dialog_div_body_left {
	float: left;
	width: 440px;
	margin-top: 20px;
	margin-bottom: 20px;
	margin-right: 50px;
	border-radius: 20px;
	box-sizing: border-box;
}

 /deep/ .dialog_div_body_right {
	float: left;
	width: 590px;
	height: auto;
}
/deep/.dialog_div_body_right_top{
	float: left;
	width: 100%;
	height: 34px;
	margin-bottom: 10px;
}

/deep/ .dialog_div_body_right_top_tab {
	float: left;
	width: auto;
	height: 34px;
	line-height: 34px;
	padding-left: 10px;
	padding-right: 10px;
font-family: "Arial" !important;
	font-size: 16px;
	color: #1290C9;
	text-align: center;
	border-radius: 6px;
	background-color: #E0F0FF;
}

/deep/.dialog_div_body_right_middle{
	float: left;
	width: 100%;
		height: auto;
	margin-bottom: 20px;
	line-height: 40px;
	 font-family: "Arial bold";
	font-size: 26px;
	color: #1A2332;
	text-align: left;
}
/deep/.dialog_div_body_right_tottom{
	float: left;
	width: 100%;
	line-height: 32px;
  font-family: "Arial" !important;
	font-size: 20px;
	color: #444444;
}

@media screen and (max-width: 1599px){
    /deep/ .swiper-pagination-bullet_first {
	width: 38px;
}
 /deep/	.header_div{
		margin-bottom: 20px;
		padding-top: 5px;
	}
/deep/	.search_no_result {
		top: 10px;
	}
	/deep/ .search_no_result_div {
		width: 400px;
		height: 60px;
		border-radius: 15px;
	}
	/deep/ .search_no_result_div_img {
		width: 20px;
		height: 20px;
		padding-top: 20px;
		padding-bottom: 20px;
		padding-left: 100px;
		margin-right: 5px;
	}
	/deep/ .search_no_result_div_text {
		width: auto;
		height: 20px;
		padding-top: 20px;
		padding-right: 20px;
		line-height: 20px;
		font-size: 14px;
	}

	 /deep/  .section_div1_div{
		width: 320px;
		height: 40px;
		border-radius: 20px;
        justify-content: center;
    display: flex;
    align-items: center;
		margin-bottom: 5px;
	}
	/deep/.section_div1_div_left{
		width: 270px;
		height: 40px;
		padding-left: 20px;
	}
	/deep/.section_div1_div_left_left{
	width: 15px;
        height: 10px;
        margin-right: 5px;
        padding-top: 13px;
        padding-bottom: 10px;
	}
	/deep/.section_div1_div_left_right{
		width: 230px;
		height: 20px;
		padding-top: 5px;
		padding-bottom: 5px;
	}
	/deep/.section_div1_div_left_right_input{
		top:11px;
		height: 20px;
		line-height: 20px;
		font-size: 12px;
	}
	/deep/.section_div1_div_right{
	width: 30px;
        height: 32px;
        padding-left: 8px;
        padding-right: 8px;
        padding-top: 12px;
        padding-bottom: 12px;
	}
	/deep/.section_div2{
		width: 1200px;
		height: 20px;
		/* margin-bottom: 10px; */
	}
	/deep/.section_div2_div{
		width: 1200px;
		height: 20px;
		line-height: 20px;
		font-size: 12px;
        font-family: "Arial bold";
	}
	/deep/.section_div3{
		width: 1200px;
		margin-bottom: 40px;
	}
	/* swiper */
	/deep/ .swiper-horizontal>.swiper-pagination-bullets, 
     /deep/ .swiper-pagination-bullet,
      /deep/ .swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 0 0 var(--swiper-pagination-bullet-horizontal-gap,5px)!important}
	   /deep/ .swiper {
		padding-top: 20px !important;
	}
/deep/	.swiper-slide {
		height: 200px;
	}
	/deep/.section_div3_pagination{
		padding-top: 10px;
		padding-bottom: 10px;
	}
	/deep/.swiper-pagination-bullet{
		height: 30px;
		line-height: 30px;
		padding-left: 4px;
		padding-right: 4px;
		border-radius: 15px;
		font-size: 12px;
        background-color: transparent ;
        opacity: 1;

	}

	/deep/.section_div3_pagination_img{
		width: 10px;
		height: 6px;
		padding-top: 12px;
		padding-bottom: 4px;
		margin-right: 3px;
	}
	/deep/.section_div3_pagination_text{
		font-size: 12px;
	}
	/deep/.section_div3_swiper{
		width: 1200px;
	}
	/deep/.section_div3_swiper_more{
		height: 20px;
		line-height: 20px;
		font-size: 14px;
	}
	/deep/.section_div3_swiper_li_margin{
		margin-right: 20px;
	}
	/deep/.section_div3_swiper li{
			width: 280px;
		height: 330px;
		margin-bottom: 25px;
		border-radius: 18px;
	}
	/deep/.section_div3_swiper_top{
	width: 265px;
		height: auto;
		padding-left: 15px;
		padding-top: 10px;
	}
	/deep/.section_div3_swiper_top_div{
		width: 250px;
		height: 160px;
		margin-bottom: 10px;
		border-radius: 10px;
	}
	/deep/.section_div3_swiper_top_text{
	width: 265px;
		line-height: 30px;
		font-size: 14px;
		margin-bottom: 5px;
        font-family: "Arial bold";
	}
    	.section_div3_swiper_top_text1 {
		width: 265px;
		height: 40px;
		line-height: 20px;
		font-size: 14px;
		margin-bottom: 5px;
	}
	/deep/.section_div3_swiper_top_text2{
			width: 255px;
		height: 46px;
		line-height: 18px;
		font-size: 14px;
	}
	/deep/.section_div3_swiper_bottom{
		bottom: 20px;
		right: 20px;
		 width: 26px;
        height: 25px;
		padding: 8px;
		border-radius: 50%;
	}
	/deep/.section_div3_swiper_bottom_div_img{
		width: 10px;
		height: 10px;
	}
	/deep/.section_bg_div {
		height: 52px;
         background: #F0F6FF ;
	}
	/deep/.footer_div{
		width: 1200px;
	}
	/deep/.footer_div_top{
		padding-bottom: 8px;
	}
	/deep/.footer_div_top_div{
		width: 45px;
		height: 15px;
	}
	/deep/.footer_div_bottom{
		padding-top: 10px;
		padding-bottom: 10px;
	}
	/deep/.footer_div_bottom_left{
		height: 10px;
		line-height: 10px;
		font-size: 12px;
	}
	/deep/.footer_div_bottom_right{
		height: 10px;
		line-height: 10px;
		font-size: 12px;
	}
	/deep/ dialog {
		width: 760px;
		border-radius: 30px;
	}
	/deep/ .dialog_div {
		width: 760px;
		height: 250px;
		padding: 20px;
	}
	/deep/ .dialog_div_close_div {
		width: 18px;
		height: 18px;
		top: 20px;
		right: 20px;
	}
	/deep/ .dialog_div_body_left {
		width: 300px;
		height: 190px;
		margin-top: 10px;
		margin-bottom: 10px;
		margin-right: 35px;
		border-radius: 12px;
	}
	/deep/ .dialog_div_body_right {
		width: 385px;
	}
	/deep/ .dialog_div_body_right_top {
		height: 22px;
		margin-bottom: 6px;
	}
	/deep/ .dialog_div_body_right_top_tab {
		height: 22px;
		line-height: 22px;
		padding-left: 6px;
		padding-right: 6px;
		font-size: 12px;
		border-radius: 4px;
	}
	/deep/ .dialog_div_body_right_middle {
		margin-bottom: 10px;
		line-height: 30px;
		font-size: 18px;
      font-family: "Arial bold";
	}
	/deep/ .dialog_div_body_right_tottom {
		line-height: 20px;
		font-size: 14px;
	}
}
/deep/.swiper-container-autoheight {
    height: auto;
}
/deep/.swiper-container-autoheight .swiper-slide {
   flex-shrink: 0;
    width: 100%;
    height: auto;
    position: relative;
    transition-property: transform;
    display: block;
    align-items: flex-start;
    transition-property: transform, height;
}
    </style>

